import { FC, PropsWithChildren, useMemo } from "react";
import { VgtVariantProps } from "./Context";
import Context from "./Context";

type Props = PropsWithChildren & VgtVariantProps;

const Provider: FC<Props> = ({ variant, children }) => {
  const value = useMemo<VgtVariantProps>(() => ({ variant }), [variant]);

  return <Context.Provider value={value}>{children}</Context.Provider>;
};

export default Provider;
